function hideEmptyBoxes() {
  console.log("hideEmptyBoxes running")

  // Hide heading
  document.querySelectorAll('.custom-section-header').forEach(section => {
    const h = section.querySelector('.text-content-heading');
    if (!h || !h.textContent.trim()) section.style.display = 'none';
  });
  
  // Hide image text list
  document.querySelectorAll('.image-text-list').forEach(section => {
    const slides = section.querySelectorAll('.slider-slide');
    const realImages = section.querySelectorAll('.slider-slide img, .slider-slide picture, .slider-slide source');
    const placeholders = section.querySelectorAll('.slider-slide .placeholder-svg');

    // If the section has slides, but all are placeholders
    const hasSlides = slides.length > 0;
    const hasRealImages = realImages.length > 0;
    const allPlaceholders = hasSlides && !hasRealImages && placeholders.length === slides.length;

    if (allPlaceholders) {
      section.style.display = 'none';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideEmptyBoxes);
} else {
  hideEmptyBoxes();
}
